import { render } from "./detailHome.vue?vue&type=template&id=338295e4&scoped=true"
import script from "./detailHome.vue?vue&type=script&lang=js"
export * from "./detailHome.vue?vue&type=script&lang=js"

import "./detailHome.vue?vue&type=style&index=0&id=338295e4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338295e4"]])

export default __exports__